import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import type { Preset, CreatePresetDto } from '../types/preset';

export function usePresets(projectId?: string) {
  return useQuery<Preset[]>({
    queryKey: ['presets', { projectId }],
    queryFn: async () => {
      const params = projectId ? `?projectId=${projectId}` : '';
      const res = await api.get(`/api/presets${params}`);
      return res.data;
    },
  });
}

export function useCreatePreset(projectId?: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreatePresetDto) => {
      const params = projectId ? `?projectId=${projectId}` : '';
      const res = await api.post(`/api/presets${params}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presets'] });
    },
  });
}

export function useUpdatePreset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }: CreatePresetDto & { id: string }) => {
      const res = await api.put(`/api/presets/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presets'] });
    },
  });
}

export function useDeletePreset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/presets/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presets'] });
    },
  });
}
